import arIcon from "../../assets/icons/ar.svg";

const ARIcon = () => {
  return <img src={arIcon} width={21} height={14} style={{ borderRadius: 2 }} />;
};

export default ARIcon;
